var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { pxToRem } from "../../utils";
export var StyledAuthHeaderButtonContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    min-width: max-content;\n    padding: 0 ", ";\n\n    & .csl-header__auth-logout-button:focus:not(:active) {\n      background: none;\n      box-shadow: ", ";\n      outline-offset: ", "rem;\n      outline: ", "rem solid transparent;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.header_auth_padding_logout;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.button_box_shadow_focus_css;
}, pxToRem(2), pxToRem(2));
export var StyledHeaderLogoLink = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    align-items: center;\n\n    &:focus {\n      box-shadow: ", ";\n      outline-offset: ", "rem;\n      outline: ", "rem solid transparent;\n    }\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.cssPrefix;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.button_box_shadow_focus_css;
}, pxToRem(2), pxToRem(2));
export var StyledHeaderButtonsContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.cssPrefix;
});
export var StyledHeaderTopContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.cssPrefix;
});
export var StyledAuthHeaderMobileButtonsContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.cssPrefix;
});
export var StyledAuthHeaderMobileButton = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    background: transparent;\n    border: none;\n    border-left: ", ";\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    min-height: ", ";\n    justify-content: center;\n    padding: ", " @media\n      (min-width: ", ") {\n      min-height: ", ";\n    }\n\n    & svg {\n      color: ", ";\n    }\n\n    &:hover:not(:focus) {\n      background: ", ";\n      color: ", ";\n\n      & svg {\n        color: ", ";\n      }\n    }\n\n    &:focus {\n      box-shadow: ", ";\n      color: ", ";\n      outline-offset: ", "rem;\n      outline: ", "rem solid transparent;\n      position: relative;\n    }\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.cssPrefix;
}, function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(pxToRem(1), "rem solid ").concat(theme.header_color_button_separator);
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.header_color_secure_information;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.header_height;
}, function (_ref13) {
  var theme = _ref13.theme;
  return "0 ".concat(theme.spacing_03, ";");
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoint_lg;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.header_height_big;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.header_color_secure_information_icon_default;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.header_color_secure_information_background_hover;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.header_color_secure_information_hover;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.header_color_secure_information_hover;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.button_box_shadow_focus_css;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.header_color_secure_information_focus;
}, pxToRem(2), pxToRem(2));
export var StyledAuthHeaderContentContainer = styled.section(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.cssPrefix;
});
export var StyledAuthHeaderContainer = styled.section(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", " {\n    background-color: ", ";\n    border-bottom: ", " solid\n      ", ";\n    display: flex;\n    flex-direction: column;\n  }\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.cssPrefix;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.header_color_auth_background;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.border_width_default;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.hr_color;
});
export var StyledAuthHeaderCustomerDetailContainer = styled.section(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", " {\n    padding: ", " & .csl-text--small {\n      display: block;\n    }\n  }\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.cssPrefix;
}, function (_ref28) {
  var theme = _ref28.theme;
  return "".concat(theme.spacing_03, " 0;");
});
export var StyledAuthHeaderLogoutContainer = styled.section(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n  }\n"])), function (_ref29) {
  var theme = _ref29.theme;
  return theme.cssPrefix;
});
export var StyledAuthHeaderHomeButtonContainer = styled.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    background: transparent;\n    border: none;\n    border-left: ", " solid\n      ", ";\n    cursor: pointer;\n    display: flex;\n    min-height: ", "rem;\n    padding: 0;\n\n    &:last-child {\n      border-right: ", " solid\n        ", ";\n    }\n\n    &,\n    svg {\n      color: ", ";\n    }\n\n    &:hover {\n      background-color: ", ";\n\n      &,\n      svg {\n        color: ", ";\n      }\n\n      span {\n        text-decoration: underline;\n      }\n    }\n\n    &:focus {\n      background-color: ", ";\n      box-shadow: ", ";\n      outline-offset: ", "rem;\n      outline: ", "rem solid transparent;\n      position: relative;\n\n      &,\n      svg {\n        color: ", ";\n      }\n    }\n  }\n"])), function (_ref30) {
  var theme = _ref30.theme;
  return theme.cssPrefix;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.border_width_default;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.hr_color;
}, pxToRem(64), function (_ref33) {
  var theme = _ref33.theme;
  return theme.border_width_default;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.hr_color;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.header_color_auth_foreground;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.header_color_auth_background_hover;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.header_color_auth_foreground_hover;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.header_color_auth_background_focus;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.button_box_shadow_focus_css;
}, pxToRem(2), pxToRem(2), function (_ref40) {
  var theme = _ref40.theme;
  return theme.header_color_auth_foreground_focus;
});
var StyledSafeSecureButtonCss = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border: none;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: ", ";\n"])), function (_ref41) {
  var $open = _ref41.$open,
    theme = _ref41.theme;
  return $open ? theme.header_color_secure_information_background : 'none';
}, function (_ref42) {
  var theme = _ref42.theme;
  return theme.header_color_secure_information;
}, function (_ref43) {
  var theme = _ref43.theme;
  return "0 ".concat(theme.spacing_03);
});
export var StyledSafeSecureButtonClickable = styled.button(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n    border: ", "rem solid transparent;\n    cursor: pointer;\n    min-height: ", ";\n\n    @media (min-width: ", ") {\n      min-height: ", ";\n    }\n    \n    & svg {\n      color: ", ";\n    }\n\n    &:focus-visible {\n      border: ", ";\n      box-shadow: ", ";\n      outline-offset: ", "rem;\n      outline: ", "rem solid transparent;\n      position: relative;\n\n      & span {\n        color: ", ";\n      }\n\n      & svg {\n        color: ", ";\n      }\n    }\n\n    &:hover {\n      background: ", ";\n\n      & span {\n        text-decoration: underline;\n        color: ", ";\n      }\n\n      & svg {\n        color: ", ";\n      }\n    }\n\n    ", "\n  }\n"])), function (_ref44) {
  var theme = _ref44.theme;
  return theme.cssPrefix;
}, StyledSafeSecureButtonCss, pxToRem(1), function (_ref45) {
  var theme = _ref45.theme;
  return theme.header_height;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.breakpoint_lg;
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.header_height_big;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.header_color_secure_information_icon_default;
}, function (_ref49) {
  var theme = _ref49.theme;
  return "".concat(pxToRem(1), "rem solid ").concat(theme.header_color_secure_information_border_focus);
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.button_box_shadow_focus_css;
}, pxToRem(2), pxToRem(2), function (_ref51) {
  var theme = _ref51.theme;
  return theme.header_color_secure_information_focus;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.header_color_secure_information_icon_focus;
}, function (_ref53) {
  var theme = _ref53.theme;
  return theme.header_color_secure_information_background_hover;
}, function (_ref54) {
  var theme = _ref54.theme;
  return theme.header_color_secure_information_hover;
}, function (_ref55) {
  var theme = _ref55.theme;
  return theme.header_color_secure_information_icon_hover;
}, function (_ref56) {
  var $open = _ref56.$open,
    theme = _ref56.theme;
  return $open && css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        &,\n        & span,\n        & svg {\n          color: ", " !important;\n          background: ", " !important;\n        }\n      "])), theme.header_color_secure_information_hover, theme.header_color_secure_information_background);
});
export var StyledSafeSecureButton = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref57) {
  var theme = _ref57.theme;
  return theme.cssPrefix;
}, StyledSafeSecureButtonCss);
export var StyledHeaderContainer = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    background: ", ";\n    display: flex;\n    min-height: ", ";\n\n    @media (min-width: ", ") {\n      min-height: ", ";\n    }\n  }\n"])), function (_ref58) {
  var theme = _ref58.theme;
  return theme.cssPrefix;
}, function (_ref59) {
  var theme = _ref59.theme;
  return theme.header_color_background;
}, function (_ref60) {
  var theme = _ref60.theme;
  return theme.header_height;
}, function (_ref61) {
  var theme = _ref61.theme;
  return theme.breakpoint_lg;
}, function (_ref62) {
  var theme = _ref62.theme;
  return theme.header_height_big;
});
export var StyledHeaderLogo = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  ", " {\n    height: ", ";\n    display: flex;\n    width: ", ";\n\n    @media (min-width: ", ") {\n      height: ", ";\n      margin: ", ";\n      width: ", ";\n    }\n\n    & svg {\n      height: 100%;\n      width: auto;\n    }\n  }\n"])), function (_ref63) {
  var theme = _ref63.theme;
  return theme.cssPrefix;
}, function (_ref64) {
  var theme = _ref64.theme;
  return theme.header_logo_height;
}, function (_ref65) {
  var theme = _ref65.theme;
  return theme.header_logo_width;
}, function (_ref66) {
  var theme = _ref66.theme;
  return theme.breakpoint_lg;
}, function (_ref67) {
  var theme = _ref67.theme;
  return theme.header_logo_height_big;
}, function (_ref68) {
  var theme = _ref68.theme;
  return "".concat(theme.header_logo_margin_big, " 0");
}, function (_ref69) {
  var theme = _ref69.theme;
  return theme.header_logo_width_big;
});
export var StyledHeaderSecureIconContainer = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", " {\n    align-items: center;\n    display: flex;\n    margin-left: ", ";\n  }\n"])), function (_ref70) {
  var theme = _ref70.theme;
  return theme.cssPrefix;
}, function (_ref71) {
  var theme = _ref71.theme;
  return theme.spacing_02;
});
export var StyledHeaderSecureTextContainer = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n  }\n"])), function (_ref72) {
  var theme = _ref72.theme;
  return theme.cssPrefix;
});
export var StyledHeaderSecureInformation = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  ", " {\n    margin: 0 auto;\n    padding: ", ";\n\n    & ul {\n      margin-top: 0;\n    }\n\n    & .csl-header__secure-information-close {\n      margin-bottom: ", ";\n    }\n  }\n"])), function (_ref73) {
  var theme = _ref73.theme;
  return theme.cssPrefix;
}, function (_ref74) {
  var theme = _ref74.theme;
  return "".concat(theme.spacing_04, " 0 ").concat(theme.spacing_05, "} 0");
}, function (_ref75) {
  var theme = _ref75.theme;
  return theme.spacing_02;
});
export var StyledHeaderSecureInformationContainer = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  ", " {\n    background: ", ";\n    transition: ", ";\n\n    @media (min-width: ", ") {\n      transition-duration: ", ";\n    }\n  }\n"])), function (_ref76) {
  var theme = _ref76.theme;
  return theme.cssPrefix;
}, function (_ref77) {
  var theme = _ref77.theme;
  return theme.header_color_secure_information_background;
}, function (_ref78) {
  var theme = _ref78.theme;
  return css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["height ", " ", ""])), theme.transition_duration_slow, theme.transition_easing_standard_css);
}, function (_ref79) {
  var theme = _ref79.theme;
  return theme.breakpoint_sm;
}, function (_ref80) {
  var theme = _ref80.theme;
  return theme.transition_duration_fast;
});
export default styled.header(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  ", " {\n    margin-bottom: ", ";\n  }\n"])), function (_ref81) {
  var theme = _ref81.theme;
  return theme.cssPrefix;
}, function (_ref82) {
  var $marginBottom = _ref82.$marginBottom,
    theme = _ref82.theme;
  return theme["spacing_".concat($marginBottom)];
});